/**
 * SessionGate Component
 * 
 * Handles authentication loading state and session resolution.
 * This is a thin wrapper that ONLY handles:
 * - Auth loading spinner display
 * - Conditional rendering based on auth state
 * 
 * NO behavior changes from original App.js - exact same rendering logic extracted.
 */

import React from 'react';

/**
 * Loading spinner shown during auth check
 */
export const AuthLoadingScreen = () => (
  <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
    <div style={{ textAlign: 'center' }}>
      <h1 className="brand-display" style={{ marginBottom: '20px' }}>SmartPlAIte</h1>
      <div className="loading-spinner" style={{ fontSize: '24px' }}>🔄</div>
      <p style={{ marginTop: '16px', color: 'var(--text-secondary)' }}>Loading...</p>
    </div>
  </div>
);

/**
 * SessionGate - Determines what to render based on auth state
 * 
 * @param {boolean} authLoading - True while checking session
 * @param {boolean} isAuthenticated - True if user is logged in
 * @param {React.ReactNode} loadingComponent - What to show while loading
 * @param {React.ReactNode} authComponent - What to show if not authenticated (login/signup)
 * @param {React.ReactNode} children - What to show if authenticated (dashboard)
 */
const SessionGate = ({ 
  authLoading, 
  isAuthenticated, 
  loadingComponent,
  authComponent,
  children 
}) => {
  // Show loading while checking auth
  if (authLoading) {
    return loadingComponent || <AuthLoadingScreen />;
  }

  // Show auth page if not authenticated
  if (!isAuthenticated) {
    return authComponent;
  }

  // Show main app (children) if authenticated
  return children;
};

export default SessionGate;
